import { render, staticRenderFns } from "./RelationPicker.vue?vue&type=template&id=0247bd20"
import script from "./RelationPicker.vue?vue&type=script&lang=ts"
export * from "./RelationPicker.vue?vue&type=script&lang=ts"
import style0 from "./RelationPicker.vue?vue&type=style&index=0&id=0247bd20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports